module.exports = __webpack_public_path__ + "img/gold-coin.fce048ad.png";